import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useCommissions = (params, options = {}) => {
  return useQuery(
    ["commissionsReport", params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getCommissionReport(), {
        params,
      });
      const composeResponse = {
        commissionType: res.data.data.commission_type,
        grouping: res.data.data.grouping,
        reportHeader: res.data.data.report_header,
        reportDataClinic: Object.values(res.data.data.report_data.clinic),
        reportDataProvider: Object.values(res.data.data.report_data.employee),
        salesHeader: res.data.data.sales_header,
        total: res.data.data.total,
        clinics: res.data.data.clinics,
      };
      return composeResponse;
    },
    options,
  );
};
